import React from "react";
import "./deleteConfirmModal.css";

const DeleteConfirmModal = ({ deleteTarget, onCancel, onConfirm, loading }) => {
  if (!deleteTarget) return null;

  return (
    <div className="dcm-overlay" onClick={onCancel}>
      <div className="dcm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dcm-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        <h3>
          {deleteTarget.type === "section" ? "Delete section?" : "Delete sub-section?"}
        </h3>
        <p>
          This will permanently remove <strong>{deleteTarget.name}</strong>
          {deleteTarget.type === "section" ? " and all its sub-sections." : "."}
        </p>

        <div className="dcm-footer">
          <button type="button" className="dcm-btn" onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button type="button" className="dcm-btn dcm-btn--danger" onClick={onConfirm} disabled={loading}>
            {loading ? "Deleting…" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;